import EncryptedStorage from 'core/utils/constants/encryptedStorage';
import { all, put, takeLatest } from 'redux-saga/effects';
import { load } from '@cashfreepayments/cashfree-js'

import { communicationSetupActions as actions } from '.';

import httpclient from 'libs/Axios/index';
import { PayloadAction } from '@reduxjs/toolkit';
import { CommunicationSetup } from './types';
import { addPageSize, ErrorMessageFunction, fetchPaymentService } from 'core/utils/constants';
import axios from 'axios';
import { API_HOST } from 'core/utils/constants/ApiConstants';
import { error } from 'core/components/Notify';
import { JWTPayload } from 'features/Authentication/slice/types';

function* fetchCommunicationSetupList(
  action: PayloadAction<{
    ID: number | string;
    DATA?: any;
    URL: string;
    ACADEMIC_YEAR_ID?: number;
    holiday_type?: string | undefined;
    TABLE_CALL?: boolean;
    authData?: any;
    TABLE_DATA?: { page_size?: string | number, page_index?: string | number }
    storeListInDifferentState?: boolean;

  }>,
) {
  const { ID, URL, ACADEMIC_YEAR_ID, holiday_type, TABLE_DATA, authData, DATA, storeListInDifferentState } = action.payload;
  const academic_year_id = URL === 'ChatThread' ? '/' : '?ACADEMIC_YEAR_ID=';
  let payload =
    `${URL === 'branchCommunicationSetting' ? 'master/' : 'comm/'}` +
    URL +
    '/list/' +
    ID +
    (URL !== 'ChatThread'
      ? (ACADEMIC_YEAR_ID ? academic_year_id + ACADEMIC_YEAR_ID : '') +
      (holiday_type ? '&holiday_type=' + holiday_type : '')
      : `?USER_ID=${authData?.USER_ID}`);

  if (["SMSRecharge", "CallRecharge"]?.includes(URL)) {
    payload = `/comm/${URL}/list/${ID}/${action.payload.ACADEMIC_YEAR_ID}`
  } else if (["CallCampaign"]?.includes(URL)) {
    payload = `/comm/${URL}/list/${ID}/${authData?.INSTITUTE_ID}`
  } else if (URL === 'AdmissionCampaign') {
    payload = `/comm/${URL}/list/${ID}?INSTITUTE_ID=${authData?.INSTITUTE_ID}`
  } else if (URL === 'ivrParentFeedback') {
    payload = `/comm/${URL}/list${ACADEMIC_YEAR_ID ? academic_year_id + ACADEMIC_YEAR_ID : ''}`
  } else if (URL === 'whatsAppCampaign') {
    payload = `/comm/${URL}/list/${ID}`
  } else if (['facebook/pages', 'instagram/accounts']?.includes(URL)) {
    payload = `/comm/${URL}?access_token=${ID}`
  } else if (['google/list']?.includes(URL)) {
    payload = `/comm/${URL}`
  // Inside fetchCommunicationSetupList in saga.ts

} else if (URL === 'smAppCampaign' || URL === 'appCampaign') {
  payload = `/comm/appCampaign/list/${ID}`;
}else if (URL === 'appTemplate') return 'appTemplate';     // Maps appTemplate -> appTemplate
  else if (URL === 'whatsapp/list') {
    payload = `/comm/${URL}?ph_id=${ID}`
  }
  const accessToken = EncryptedStorage.getItem('_UFT_');
  const headers = {
    ...(accessToken ? { Authorization: accessToken } : {}),
    'access-token': ID,
    'branch-id': JSON.parse(EncryptedStorage.getItem('_DATA_') || '{}')?.BRANCH_ID,
    'database': EncryptedStorage.getItem('_DATABASE_'),
    // Add other headers if needed
  };

  try {
    const response = yield ['facebook/pages', 'instagram/accounts']?.includes(URL) ?
      axios.get(`${API_HOST}comm/${URL}`, { headers }) :
      (['google/list', 'whatsapp/list']?.includes(URL) ? axios.post(`${API_HOST}${payload}`, DATA, { headers }) : httpclient().get(addPageSize(payload, TABLE_DATA))); // removed TABLE_DATA
    const data = response?.data?.data;
    if (['facebook/pages', 'instagram/accounts', 'google/list', 'whatsapp/list']?.includes(URL) && ![200, 201]?.includes(Number(response?.data?.code))) {
      if (['facebook/pages', 'instagram/accounts']?.includes(URL)) {
        error(ErrorMessageFunction({ externalURL: "https://www.facebook.com/business/help/473994396650734?id=939256796236247", customMessage: response?.data?.message, name: "Meta page" }), true);
      }
      yield put(actions.fetchCommunicationSetupListFailure(response?.data?.message));
    } else {
      if (["SMSRecharge", "CallRecharge"]?.includes(URL)) {
        yield put(actions.fetchCommunicationSetupListSuccess(data));
      } else {
        if ((data?.list?.length || data?.length) === 0) {
          let messageHolder = "";
          if (DATA?.SERVICE === "gb") {
            messageHolder = "Logged-in account has no associated business.";
          } else if (DATA?.SERVICE === "yt") {
            messageHolder = "Logged-in account has no associated channels.";
          } else if (['facebook/pages', 'instagram/accounts']?.includes(URL)) {
            messageHolder = "Logged-in account has no associated Pages.";
          }
          if (messageHolder) {
            error(ErrorMessageFunction({ externalURL: ['facebook/pages', 'instagram/accounts']?.includes(URL) ? "https://www.facebook.com/pages/creation" : "https://business.google.com/create", customMessage: messageHolder, name: ['facebook/pages', 'instagram/accounts']?.includes(URL) ? "Meta page" : "Google" }), true);
          }
        }
        const listData = data[Object.keys(data).at(0)?.toString() as string] || [];
        yield put(actions.fetchCommunicationSetupListSuccess({ listData, data, storeListInDifferentState }));
      }
    }
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.fetchCommunicationSetupListFailure(errorDetails));
  }
}

function* fetchCommunicationSetupOne(
  action: PayloadAction<{ ID: number; URL: string, authData?: JWTPayload }>,
) {
  const { ID, URL, authData } = action.payload;

  function convertToSnakeCase(input: string): string {
    const snakeCase = input.replace(/([A-Z])/g, '_$1').toLowerCase();
    return snakeCase.replace(/^_/, '');
  }

  const updatedUrl: string = (() => {
    switch (URL) {
      case 'CallCampaign':
      case 'smsCampaign':
        case 'appCampaign': 
        return 'id';
        case 'smAppCampaign':
        return 'id';
      case 'whatsAppCampaign':
        return 'id';
      case 'whatsappTemplate':
        return 'WHATSAPP_TEMPLATE_ID'
      case 'CommunicationRecharge':
        return 'COMMUNICATION_RECHARGE_ID';
      case 'ChatThread':
        return 'chat_group_id';
      case 'admissionCampaignNumber':
        return 'ADMISSION_CAMPAIGN_NUMBER_ID'
      case 'AdmissionCampaign':
        return 'ADMISSION_CAMPAIGN_ID'
      case 'event':
        return 'id'
      default:
        return `${convertToSnakeCase(URL)}_id`;
    }
  })();

 const hasBranchId = URL === 'branchCommunicationSetting' ? `&BRANCH_ID=${authData?.BRANCH_ID}` : ''

  try {
    
    let mappedUrl = URL;
    if (URL === 'ChatThread') mappedUrl = 'ChatGroup';
    if (URL === 'smAppCampaign') mappedUrl = 'appCampaign';

    const response = yield httpclient().get(`/${URL === 'branchCommunicationSetting' ? 'master' : 'comm'}/${mappedUrl}/view?${updatedUrl}=${ID}${hasBranchId}`);
    const data = response?.data?.data;

    // const listData = data[Object.keys(data).at(0)?.toString() as string];
    yield put(actions.fetchCommunicationSetupOneSuccess(data));
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.fetchCommunicationSetupOneFailure(errorDetails));
  }
}

function* createCommunicationSetup(
  action: PayloadAction<{
    data: CommunicationSetup | any;
    URL: string | any;
    action?: string;
    authData?: any;
    message: string;
  }>,
) {
  const { URL, message, authData } = action.payload;


 
  let newUrl = URL;
  if (URL === 'ChatThread') {
    newUrl = 'ChatConversation';
  } else if (URL === 'smAppCampaign') {
    newUrl = 'appCampaign';
  } 
  
  if (URL === "createOrder") {
    let temp;
    if (!!action.payload?.data?.CashFreeOrderRequest) {
      const { CashFreeOrderRequest, ...reset } = action.payload?.data;
      temp = { ...reset };
    }
    const response = yield httpclient().post(`/comm/CommunicationRecharge/save`, temp);
    const data = response?.data?.data;
    if (!!data?.ORDER_ID) {
      const payload = {
        ...action.payload?.data?.CashFreeOrderRequest,
        PAYMENT_METHOD: action.payload?.data?.PAYMENT_METHOD,
        ORDER_ID: data?.ORDER_ID,
        AMOUNT: data?.AMOUNT,
        CUS_ID: data?.CUS_ID,
      }
      const response = yield httpclient().post(`/payment/${fetchPaymentService(authData)}/createOrder`, payload);
      const paymentData = response?.data?.data;
      if (paymentData?.payment_session_id) {
        yield put(actions.createCommunicationSetupSuccess("PAYMENT_SUCCESS"));
        var initializeSDK = async function () {
          const cashfree = await load({
            mode: "sandbox"
          });
          let checkoutOptions = {
            paymentSessionId: paymentData?.payment_session_id,
            redirectTarget: "_self",
          };
          cashfree?.checkout(checkoutOptions);
        };
        initializeSDK();
      }
    }
  } else {
    try {
      let url = `/${URL === 'branchCommunicationSetting' ? 'master' : 'comm'}/${newUrl}/${URL === 'CommunicationRecharge' ? 'save' : 'upsert'}`;
      if (["facebook/update_info", "google/update_info", "whatsapp/selectBusiness"]?.includes(URL)) {
        url = `/comm/${URL}`
      }
      const response = yield httpclient().post(
        url, // ChatConversation has been added in place of ${URL}
        action.payload.data);
      yield put(
        actions.createCommunicationSetupSuccess({
          message,
          flag: (action.payload.action === "NOT_CALL"),
          data: response?.data?.data,
          URL
        }),
      );
    } catch (error: any) {
      const errorDetails = error?.response?.message || error?.message;
      yield put(actions.createCommunicationSetupFailure(errorDetails));
    }
  }
}

function* deleteCommunicationSetup(
  action: PayloadAction<{ URL: string; ID: number, authData?: JWTPayload }>,
) {
  const { URL, ID, authData } = action.payload;

  const hasBranchId = URL === 'branchCommunicationSetting' ? `&BRANCH_ID=${authData?.BRANCH_ID}` : ''
  try {
    const response = yield httpclient().delete(`/${URL === 'branchCommunicationSetting' ? 'master' : 'comm'}/${URL}/delete?id=${ID}${hasBranchId}`);
    const data = response?.data?.data;
    yield put(actions.deleteCommunicationSetupSuccess(data));
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.deleteCommunicationSetupFailure(errorDetails));
  }
}

export function* communicationSetupSaga() {
  yield all([
    takeLatest(
      actions.fetchCommunicationSetupListStart.type,
      fetchCommunicationSetupList,
    ),
    takeLatest(
      actions.fetchCommunicationSetupOneStart.type,
      fetchCommunicationSetupOne,
    ),
    takeLatest(
      actions.createCommunicationSetupStart.type,
      createCommunicationSetup,
    ),
    takeLatest(
      actions.deleteCommunicationSetupStart.type,
      deleteCommunicationSetup,
    ),
  ]);
}
